import React from 'react';
import {connect} from 'react-redux';
import {change} from 'redux-form';
import {
    Create,
    SimpleForm,
    TextInput,
    NumberInput,
    SelectInput,
    BooleanInput,
    required,
    minValue,
    maxValue,
} from 'react-admin';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {
    dripCampaignWizardInitialize,
    dripCampaignWizardSave
} from '../../actions/dripCampaignActions';
import {
    dripCampaignSelectCampaign,
    dripCampaignSelectWizard,
    dripCampaignSelectWizardLoading,
    dripCampaignSelectMessages,
    dripCampaignSelectGroups,
    dripCampaignSelectSenders
} from '../../selectors/dripCampaignSelector';
import DripCampaignToolbar from './DripCampaignToolbar';
import DripCampaignFilters from './DripCampaignFilters';

class DripCampaignCreate extends React.Component {
    componentDidMount() {
        const {wizard, wizardInitialize} = this.props;

        if (!wizard.initialized) {
            wizardInitialize();
        }
    }

    render() {
        const {dripCampaign, change, dispatch, save, wizard, wizardLoading, wizardInitialize, messages, groups, senders, t, tReady, ...rest} = this.props;

        return (
            <Create {...rest} title={t('drip.create_title')}>
                <SimpleForm
                    toolbar={<DripCampaignToolbar save={save} saving={(wizard && wizard.saving) || wizardLoading || false} />}
                    defaultValue={{
                        name: '',
                        subject: '',
                        sender: null,
                        message: null,
                        targetGroup: null,
                        triggerType: 'contact_created',
                        delayInHours: 24,
                        isActive: true
                    }}
                >
                    <TextInput
                        source="name"
                        label={t('drip.name')}
                        validate={[required()]}
                        fullWidth
                    />

                    <TextInput
                        source="subject"
                        label={t('drip.subject')}
                        validate={[required()]}
                        helperText={t('drip.subject_help')}
                        fullWidth
                    />

                    <SelectInput
                        source="sender"
                        label={t('drip.sender')}
                        choices={senders}
                        optionText={(sender) => sender.name ? `${sender.name} <${sender.email}>` : sender.email}
                        optionValue="id"
                        validate={[required()]}
                        helperText={t('drip.sender_help')}
                        fullWidth
                    />

                    <SelectInput
                        source="message"
                        label={t('drip.base_campaign')}
                        choices={messages}
                        optionText="name"
                        optionValue="id"
                        validate={[required()]}
                        fullWidth
                    />

                    <SelectInput
                        source="targetGroup"
                        label={t('drip.target_group')}
                        choices={groups}
                        optionText="name"
                        optionValue="id"
                        validate={[required()]}
                        helperText={t('drip.target_group_help')}
                        fullWidth
                    />

                    <SelectInput
                        source="triggerType"
                        label={t('drip.trigger_type')}
                        choices={[
                            { id: 'contact_created', name: t('drip.trigger.contact_created') },
                            { id: 'contact_updated', name: t('drip.trigger.contact_updated') },
                            { id: 'manual_enrollment', name: t('drip.trigger.manual_enrollment') },
                        ]}
                        validate={[required()]}
                        helperText={t('drip.trigger_type_help')}
                        fullWidth
                    />

                    <NumberInput
                        source="delayInHours"
                        label={t('drip.delay_in_hours')}
                        validate={[required(), minValue(1), maxValue(8760)]}
                        helperText={t('drip.delay_in_hours_help')}
                        fullWidth
                    />

                    <BooleanInput
                        source="isActive"
                        label={t('drip.is_active')}
                        defaultValue={true}
                    />

                    <DripCampaignFilters/>
                </SimpleForm>
            </Create>
        );
    }
}

DripCampaignCreate.propTypes = {
    dripCampaign: PropTypes.object.isRequired,
    change: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
    wizard: PropTypes.object.isRequired,
    wizardInitialize: PropTypes.func.isRequired,
    messages: PropTypes.array.isRequired,
    groups: PropTypes.array.isRequired,
    senders: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        dripCampaign: dripCampaignSelectCampaign(state),
        wizard: dripCampaignSelectWizard(state),
        wizardLoading: dripCampaignSelectWizardLoading(state),
        messages: dripCampaignSelectMessages(state),
        groups: dripCampaignSelectGroups(state),
        senders: dripCampaignSelectSenders(state),
    }
};

const mapDispatchToProps = dispatch => {
    return {
        change: (field, value) => dispatch(change('record-form', field, value)),
        save: () => dispatch(dripCampaignWizardSave('list')),
        wizardInitialize: () => dispatch(dripCampaignWizardInitialize()),
    }
};

const DripCampaignCreateWithTranslation = (props) => {
    const {t} = useTranslation();
    return <DripCampaignCreate {...props} t={t} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(DripCampaignCreateWithTranslation);